export default "__VITE_ASSET__85eddc7c__"